import { render } from "./RejectIcon.vue?vue&type=template&id=5b62deb0"
import script from "./RejectIcon.vue?vue&type=script&lang=js"
export * from "./RejectIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__